import React, { useEffect, useState } from 'react'
import LoadSpinner from '../../../components/load-spinner/LoadSpinner';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CustomTable from '../../../components/custom-table/CustomTable';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import useDoor from '../../../hooks/useDoor';
import { toast } from 'react-toastify';
import DoorLogsModal from '../../../components/modals/door-logs-modal/DoorLogsModal';
import { setSelectedDoor, setShowEditDoorModal } from '../../../slice/editDoorSlice';
import { setShowDoorLogsModal } from '../../../slice/showModalSlice';
import EditDoorModal from '../../../components/modals/edit-door-modal/EditDoorModal';
import DoorHistoryModal from '../../../components/modals/door-history-modal/DoorHistoryModal';

const DashboardDoor = () => {
        // const { getLabel } = useLabel()
    const [doors,setDoors] = useState([]);

    const dispatch = useDispatch();
    const showDoorLogsModal = useSelector((state)=>state.showModal.showDoorLogsModal);
    const showEditDoorModal = useSelector((state)=>state.editDoor.showEditDoorModal);
    //const showCreateModal = useSelector((state)=>state.showModal.showCreateTagDoorModal);
    const { getDoors, doorLoading } = useDoor();

    useEffect(()=>{
        getDoorsData();
    },[])

    const getDoorsData = () => {
      getDoors(
        (data)=>{
            setDoors(data.content)
        },
        ()=>{
          toast.error("Errore nel ricevere i dati relativi alle  porte")
        },
        false
      )
    }


    const headerTable = [
        { label: "Nome", field: "name", width: 270 },
        { label: "Seriale", field: "serialNumber", width: 270 },
        { label: "Modello", field: "model", width: 270 },
    ];

  const dataForTable = (doors || []).map((door) => ({
    ...door,
    clickEvent: () => {
      dispatch(setSelectedDoor(door));
      dispatch(setShowEditDoorModal())
    },
    // palette: <div className='ms-auto me-auto' style={{backgroundColor:`${label.color}`,width:"25px", height:"25px", borderRadius:"50%"}}></div>
  }));




  return (
    <>
      <div className="container-fluid">
        <div className='row px-3'>
          <div className="d-flex align-items-center justify-content-between mb-4 px-1">
            <h1 className="h1 mb-2 text-primary-custom">Dashboard Porte</h1>
          </div>
        </div>
        <div className="row mb-3">
          {doorLoading
          ?<LoadSpinner/>
          :<CustomTable
            clickIcon={faMagnifyingGlass}
            header={headerTable}
            data={dataForTable}
            checkable={false}
            label='Porte'/>
          }
        </div>
      </div>
      {showDoorLogsModal && <DoorLogsModal/>}
      {showEditDoorModal && <EditDoorModal onSuccess={()=>getDoorsData()}/>}
        <DoorHistoryModal />
    </>
  );
}

export default DashboardDoor